import { render, staticRenderFns } from "./GroupWrapper.vue?vue&type=template&id=5be57a02"
import script from "./GroupWrapper.vue?vue&type=script&lang=js"
export * from "./GroupWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports